import { type FC } from "react";

import { HeaderItem } from "../../../../shared/components";

import { actionsWidth } from "./HeaderWidth.styles";

export const BusinessHeaderItems: FC = () => {
    const actionsCount = 1;

    return <HeaderItem className={actionsWidth(actionsCount)} />;
};
